/**
 * Created by OBL on 14/01/2016.
 */
define('adminLmbAnalyzersController',[
    'module',
    'underscore',
    'app',
    'adminLmbAnalyzersView',
    'bootbox',
    'lmbAnalyzerCreateEditLayoutView',
    'settings',
    'entities/lmbanalyzers'
], function(
    module,
    _,
    App,
    View,
    bootbox,
    CreateEditLayoutView
    ) {
    'use strict';

    var AdminLmbAnalyzerListController = {
        showLmbAnalyzerList: function(data) {
            var view = new View({data: data});
            this.view = view;
            view.listenTo(view, 'onGridLoaded', _.bind(this.onGridLoaded, this));
            view.listenTo(view, 'lmbanalyzer:delete', _.bind(this.onDelete, this));
            App.regions.getRegion('main').currentView.getRegion('content').show(view);
        },

        showLmbAnalyzerAdd: function() {
            this.createEditView = new CreateEditLayoutView({
                lmbAnalyzerModel: App.request('lmbanalyzer:model'),
                newItem: true
            });
            this.createEditView.show({
                title: _.i18n('lmbanalyzer.new')
            });
        },

        onGridLoaded: function() {
            var data = {
                url: App.request('lmbanalyzer:get-collection-url'),
                rowCountUrl: App.request('lmbanalyzer:get-count-url')
            };

            this.view.displayGrid(data);
        },

        onDelete: function(secId){
            bootbox.confirm(_.i18n('lmbanalyzer.confirmDelete'), _.bind(function(result) {
                if(result){
                    App.request('lmbanalyzer:delete', secId)
                        .done(_.bind(function(){
                            this.view.updatePagination('reloadGrid');
                        }, this));
                }
            }, this));
        }
    };

    module.exports = AdminLmbAnalyzerListController;
});
